import api from './api';

const unwrap = async (request) => {
  const { data } = await request();
  return data;
};

export const listDocumentProfiles = async (documentType) => unwrap(() => api.get('/document-profiles', {
  params: documentType ? { document_type: documentType } : undefined,
}));

export const createDocumentProfile = async (payload) => unwrap(() => api.post('/document-profiles', payload));
export const updateDocumentProfile = async (id, payload) => unwrap(() => api.put(`/document-profiles/${id}`, payload));
export const deleteDocumentProfile = async (id) => unwrap(() => api.delete(`/document-profiles/${id}`));

export const resolveDocumentProfile = async (documentType, context = {}) => unwrap(() => api.get('/document-profiles/resolve', {
  params: {
    document_type: documentType,
    ...context,
  },
}));

export const listDocumentNumberSeries = async (documentType) => (await api.get('/document-number-series', { params: { document_type: documentType } })).data;
export const saveDocumentNumberSeries = async (payload) => (await api.put('/document-number-series', payload)).data;
